"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentCardLocation = void 0;
var Utilities_1 = require("../../Utilities");
var DocumentCardLocation_base_1 = require("./DocumentCardLocation.base");
var DocumentCardLocation_styles_1 = require("./DocumentCardLocation.styles");
exports.DocumentCardLocation = (0, Utilities_1.styled)(DocumentCardLocation_base_1.DocumentCardLocationBase, DocumentCardLocation_styles_1.getStyles, undefined, { scope: 'DocumentCardLocation' });
//# sourceMappingURL=DocumentCardLocation.js.map